import Vue from "vue";
import VueRouter from "vue-router";
// 布局
import Layout from "../views/layout/";

// 手机端路由
import routerM from "./routerM";
// 神策埋点
// import sensors from '@/utils/sensors.js';

Vue.use(VueRouter);

// 判断设备
const ISMOBILE = function () {
  let flag = false
  let ua = navigator.userAgent
  if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua) || /micromessenger/i.test(ua)) {
    flag = true
  }
  return flag
}

// 路由格式统一采用这种默认chuank打包方式，统一写法，非必要不要擅改
const routes = [
  {
    path: "/",
    component: Layout,
    children: [
      {
        path: "/",
        redirect: "/index", // 页面重定向
      },
      // {
      //   // 主页 审核专用页面
      //   path: "/index",
      //   name: "Index",
      //   component: () =>
      //     import(/* webpackChunkName: "Medilink" */ "../views/home/index"),
      // },
      {
        // 主页
        path: "/index",
        name: "Index",
        component: () =>
          import(/* webpackChunkName: "Medilink" */ "../views/index"),
      },
      {
        // 关于我们
        path: "/about",
        name: "About",
        component: () =>
          import(/* webpackChunkName: "About" */ "../views/about"),
      },
      {
        // 个人健康管理
        path: "/products/personal",
        name: "Product",
        component: () =>
          import(
            /* webpackChunkName: "Product" */ "../views/products/personal"
          ),
      },
      // 企业健康服务
      {
        path: "/thirdService/healthPlan",
        name: "HealthPlan",
        component: () =>
          import(
            /* webpackChunkName: "HealthPlan" */ "../views/thirdService/healthPlan.vue"
          ),
      },
      // 第三方管理服务-会员服务
      {
        path: "/vipService",
        name: "VipService",
        component: () =>
          import(
            /* webpackChunkName: "managementService" */ "../views/managementService/VipService.vue"
          ),
      },
      // 第三方管理服务-特色服务
      {
        path: "/specialService",
        name: "SpecialService",
        component: () =>
          import(
            /* webpackChunkName: "managementService" */ "../views/managementService/SpecialService.vue"
          ),
      },
      // 第三方管理服务
      {
        path: "/thirdService/thirdPartService",
        name: "ThirdPartService",
        component: () =>
          import(
            /* webpackChunkName: "ThirdPartService" */ "../views/thirdService/thirdPartService.vue"
          ),
      },
      {
        // 中间带-诊所
        path: "/medicalService/clinic/:clinic",
        name: "MedicalClinic",
        component: () =>
          import(
            /* webpackChunkName: "medicalService" */ "../views/medicalService/clinic"
          ),
      },
      {
        path: "/upgrade",
        name: "upgrade",
        component: () => import("../views/upGrade"),
      },
      {
        // 医疗服务-企业健康小屋∏
        path: "/medicalService/company",
        name: "MedicalCompany",
        component: () =>
          import(
            /* webpackChunkName: "medicalService" */ "../views/medicalService/company"
          ),
      },
      {
        // 产品详情 --新燕宝2022
        path: "/productDetails/:productCode",
        name: "productDetails",
        component: () =>
          import(/* webpackChunkName: "Product" */ "../views/productDetails/index-common.vue"),
      },
      {
        // 产品详情 --新燕宝2022
        path: "/productDetails",
        name: "productDetails",
        component: () =>
          import(/* webpackChunkName: "Product" */ "../views/productDetails"),
      },
      {
        // 产品详情 -- 喜燕宝
        path: "/productDetails2",
        name: "productDetails2",
        component: () =>
          import(
            /* webpackChunkName: "Product" */ "../views/productDetails/index2"
          ),
      },
      {
        // 产品详情 -- 福燕宝
        path: "/productDetails3",
        name: "productDetails3",
        component: () => import(/* webpackChunkName: "Product" */ "../views/productDetails/index3"),
      },
      {
        // 产品详情 -- 臻荣耀个人全球医疗保险2022
        path: "/productDetails4",
        name: "productDetails4",
        component: () => import(/* webpackChunkName: "Product" */ "../views/productDetails/index4"),
      },
      {
        // 产品详情 -- 小燕宝
        path: "/productDetails5",
        name: "productDetails5",
        component: () => import(/* webpackChunkName: "Product" */ "../views/productDetails/index5"),
      },
      {
        // 产品详情 -- 臻合意
        path: "/productDetails6",
        name: "productDetails6",
        component: () => import(/* webpackChunkName: "Product" */ "../views/productDetails/index6"),
      },
      {
        // 产品详情 -- 臻高端
        path: "/productDetails7",
        name: "productDetails7",
        component: () => import(/* webpackChunkName: "Product" */ "../views/productDetails/index7"),
      },
      {
        // 产品详情 -- 喜燕宝全球版
        path: "/productDetails8",
        name: "productDetails8",
        component: () => import(/* webpackChunkName: "Product" */ "../views/productDetails/index8"),
      },
      {
        path: "/medicalNetwork",
        name: "medicalNetwork",
        component: () => import(/* webpackChunkName: "medicalNetwork" */ "../views/medicalNetwork/layout.vue"),
        redirect: "/medicalNetwork/mainland",
        children: [
          {
            path: "mainland", //大陆
            name: "mainland",
            component: () => import(/* webpackChunkName: "medicalNetwork" */ "../views/medicalNetwork/mainland.vue"),
          },
          {
            path: "overseas", //海外
            name: "overseas",
            component: () => import(/* webpackChunkName: "medicalNetwork" */ "../views/medicalNetwork/overseas.vue"),
          },
          {
            path: "joinin", //加入我们
            name: "joinin",
            component: () => import(/* webpackChunkName: "medicalNetwork" */ "../views/medicalNetwork/joinin.vue"),
          },
        ],
      },
    ],
  },
];

// 根据设备判断路由文件
const router = new VueRouter({
  mode: "history",
  base:
    process.env.NODE_ENV === "yt"
      ? "/middle/"
      : process.env.NODE_ENV === "test"
      ? "/medilinkfront"
      : "/MediLink",
      routes: ISMOBILE() ? routerM : routes
});


// 根据设备跳转路由
router.beforeEach((to, from, next) => {
  const clientW = document.body.clientWidth
  let enPathIndex = to.path.indexOf('/langEn')
  if(enPathIndex > -1) {
    sessionStorage.setItem('lang', 'en')
    let nowPath = to.path.substring(0, enPathIndex)
    if (clientW < 768 && !to.path.includes('/m/')) {
      next({ path: '/m' + nowPath, query: to.query })
    } else {
      next({ path: nowPath, query: to.query })
    }
    return
  }
  if (clientW < 768 && !to.path.includes('/m/')) {
    next({ path: '/m' + to.path, query: to.query })
  } else {
    next()
  }
});
/*eslint-disable*/
// router.afterEach((to) => {
//   // 页面埋点
//   sensors();
// });

//以下代码解决路由地址重复点击的报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
